<template>
    <div>
        <el-page-header @back="goBack" content="中奖信息管理">
        </el-page-header>
        <div style="margin-bottom: 10px;margin-top: 25px">

            <table>
                <tr>
                    <td>
                        <span>用户编号：</span>
                        <el-input v-model="queryData.did" style="width: 200px" clearable></el-input>
                    </td>
                    <td>
                        <span>联系人手机号：</span>
                        <el-input v-model="queryData.receiveMobile" style="width: 200px" clearable></el-input>
                    </td>
                    <td>
                        <span class="demonstration">日期：</span>
                        <el-date-picker
                            v-model="queryData.timeDate"
                            type="daterange"
:clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </td>
                    <td>
                        <span>状态：</span>
                        <el-select v-model="queryData.receiveType" filterable placeholder="请选择/输入">
                            <el-option
                                v-for="item in receiveType"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </td>
                    <td>
                        <el-button type="primary" @click="query">查询</el-button>
                    </td>
                </tr>
            </table>
        </div>

        <div>
            <el-table border :data="prizes">
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column prop="createDt" label="日期" :formatter="formatDateYMD"></el-table-column>
                <el-table-column prop="prizeName" label="物品"></el-table-column>
                <el-table-column prop="createDt" label="领取时间" :formatter="formatDate"></el-table-column>
                <el-table-column prop="did" label="用户编号"></el-table-column>
                <el-table-column prop="receiveName" label="联系人姓名"></el-table-column>
                <el-table-column prop="receiveMobile" label="联系人手机号"></el-table-column>
                <el-table-column prop="receiveAddressDetail" label="收货地址"></el-table-column>

                <el-table-column prop="receiveTypeName" label="发货状态">
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="success" round
                                   @click="setReceiveType(scope.row,1)">通过</el-button>
                        <el-button type="warning" round
                                   @click="setReceiveType(scope.row,2)">拒绝</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[20,50,100]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
            </el-pagination>
        </div>

    </div>

</template>

<script>

import {formatDate, queryPrizeReceive, receiveType, updatePrizeReceive} from "@/http/api";
import utils from "@/utils";

export default {
    inject: ['reload'],
    name: "SendList",
    data() {
        return {
            queryData: {
                timeDate: null,
                did: null,
                receiveMobile: null,
                receiveType: null
            },
            prize: {
                id: null,
                did: null,
                receiveType: null
            },
            prizes: null,
            headers: {},
            page: {
                size: 20,
                page: 1,
                totalElements: null
            },
            receiveType: null
        }
    },
    methods: {
        formatDate(row, column) {
            return formatDate(row, column);
        },
        formatDateYMD(row, column) {
            return utils.DateUtil.formatDate(row[column.property], "YYYY-MM-DD");
        },
        goBack() {
            this.$router.push({path: '/ActivitySummary'})
        },
        query() {
            this.queryData.page = this.page.page;
            this.queryData.size = this.page.size;
            if (this.queryData.timeDate === null) {
                this.queryData.timeDate = ['', ''];
            }
            this.queryData.startDt = this.queryData.timeDate[0];
            this.queryData.endDt = this.queryData.timeDate[1];
            queryPrizeReceive(this.queryData).then(resp => {
                this.prizes = resp.data.info.list;
                this.page.totalElements = resp.data.info.totalElements;
                this.headers = {Authorization: this.$store.state.user.token};
            });
        },
        setReceiveType(prize, receiveType) {
            updatePrizeReceive({
                "prizeTableId": prize.id,
                "receiveType": receiveType,
                "did": prize.did
            }).then(resp => {
                if (resp.data.status === 0) this.query()
            });

        },
        handleSizeChange(size) {
            this.page.size = size;
            this.query();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.query();
        },
    },
    created() {
        receiveType().then(resp => {
            this.receiveType = resp.data.info;
            this.receiveType.push({"id": null, "name": "全部"});
        });
        this.query();
    }
}
</script>

<style lang="less">
.sub {
    position: relative;
    left: 570px
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 60px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 60px;
}

.avatar {
    width: 100px;
    height: 100px;
    display: block;
}

.avatar1 {
    width: 150px;
    height: 200px;
    display: block;
}

.elalert {
    max-width: 89%;
    left: 11%;
}

.iconSize {
    font-size: 14px;
    font-weight: normal;
}

</style>
